import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from 'react-modal';
import { modalStyle, mediumModalStyle } from '../../constants';
import moment from 'moment';
import axios from 'axios';
import { DateField } from './schedule_utils';
import { getCurrentDate, getDateValue, getNext10Days } from '../../utils/date';
import { withAuth } from '../../actions/';
import { fetchTrackingPhase_AE, fetch_lkp_ReviewStatus_AE, getAETrackingByProjectId, getPmLogByPhaseId_AE, 
    getPmLogByProjectId_AE, getDocsByProjectId, getDocTypesAEByPhaseId, fetch_lkp_StatusTracking_AE } from '../../actions/additional_actions';

class RfsNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            aeTrack: {},
            aeTrackBottomPartArray: [],
            modalCommentsVisible: false,
            commentInModal: '',
            modalIsOpenSave: false,
            modalIsOpenSubmit: false,
            showSavedMsg: false,
            next10days: getNext10Days(),

            modalIsOpenLog: false,
            pmComment: '',
            docWarning: false,
            deleteDoc: false,
            doc: null,
            modalIsOpenDoc: false,
        }

        this.confirmSubmitPhase = this.confirmSubmitPhase.bind(this);
        this.confirmSavePhase = this.confirmSavePhase.bind(this);
        this.submitFirstPhase = this.submitFirstPhase.bind(this);
        this.submitNextPhase = this.submitNextPhase.bind(this);
        this.savePhase = this.savePhase.bind(this);
        this.putTrackingPhase = this.putTrackingPhase.bind(this);
        this.putMainTrack = this.putMainTrack.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);

        this.postTargetDateLog = this.postTargetDateLog.bind(this);
        this.createTargetDateLog = this.createTargetDateLog.bind(this);
        this.handleChangeComment = this.handleChangeComment.bind(this);

        this.reloadDocs = this.reloadDocs.bind(this);
        this.showDocWarning = this.showDocWarning.bind(this);
        this.validateSubmission = this.validateSubmission.bind(this);
        this.onDocDelete = this.onDocDelete.bind(this);
        this.onDocDeleteCancel = this.onDocDeleteCancel.bind(this);
        this.handleDocDelete = this.handleDocDelete.bind(this);
        this.deleteBlob = this.deleteBlob.bind(this);
        this.delDocumentToAPI = this.delDocumentToAPI.bind(this);
        this.onDocDownload = this.onDocDownload.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { projectId, trackingPhases_AE, reviewStatuses_AE, pmLogsByProjectId_AE, statusTracking_AE } = this.props;
        const { aeTrack } = this.state;
        const aeTrackBottomPartArray = this.state;

        this.props.getAETrackingByProjectId(projectId);
        this.props.fetchTrackingPhase_AE(projectId);
        this.props.getDocsByProjectId(this.props.projectId);

        if (reviewStatuses_AE.length === 0) this.props.fetch_lkp_ReviewStatus_AE();
        if (pmLogsByProjectId_AE.length === 0) this.props.getPmLogByProjectId_AE(projectId);

        this.setState({ aeTrack: this.props.aeTracksMain[0], aeTrackBottomPartArray: trackingPhases_AE });

        // PO phase 
        if (aeTrack === undefined || aeTrackBottomPartArray.length === 0) {
            this.props.getDocTypesAEByPhaseId(19);
        }
        if (statusTracking_AE) this.props.fetch_lkp_StatusTracking_AE();     
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.aeTracksMain[0] !== nextProps.aeTracksMain[0])
            this.setState({ aeTrack: nextProps.aeTracksMain[0] })

        if (nextProps.trackingPhases_AE.length > 0)
            this.setState({ aeTrackBottomPartArray: nextProps.trackingPhases_AE })
    }

    calcDaysRemaining(row) {
        var daysLeft = null;

        if ((row.aeActualReviewedDate !== null && row.aeActualReviewedDate !== undefined && row.aeActualReviewedDate !== '') &&
            (row.aeAcceptedDate !== null && row.aeAcceptedDate !== undefined && row.aeAcceptedDate !== '')) {
            var tgDate = new Date(row.aeActualReviewedDate);
            var tgDateMoment = moment(tgDate);

            var aeAccDate = new Date(row.aeAcceptedDate);
            var aeAccDateMoment = moment(aeAccDate);

            daysLeft = tgDateMoment.diff(aeAccDateMoment, 'days');
        }
        return daysLeft;
    }

    getReviewStatusName(reviewStatusId) {
        let label = _.find(this.props.reviewStatuses_AE, function (s) { return s.id === reviewStatusId });
        if (label !== undefined)
            return label.reviewStatus;
        else return null;
    }

    getStatusTracking(statusTrackingId) {
        let label = _.find(this.props.statusTracking_AE, function (s) { return s.id === statusTrackingId });
        if (label !== undefined)
          return label.status;
        else return null;
      }

    handleDateChange(name, index) {
        return (date) => {
            const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
            aeTrackBottomPartArray[index][name] = date;
            this.setState({ aeTrackBottomPartArray, pmComment: '' });
        }
    }

    handleChangeComment(field) {
        return (e) => {
            this.setState({ [field]: e.target.value });
        };
    }

    showCommentsModal(row) {
        this.setState({ modalCommentsVisible: true, commentInModal: row.comments });
    }

    closeModal() {
        this.setState({
            modalIsOpenSubmit: false, modalCommentsVisible: false, modalIsOpenSave: false, modalIsOpenLog: false,
            deleteDoc: false, modalIsOpenDoc: false,
        });
    }

    validateSubmission() {
        const currentDocs = this.props.docs_AE;
        const docTypes = this.props.docTypes_AE;

        if (docTypes.length > 0)
        {
            var docTypesMandatory = docTypes.filter(doc => doc.isMandatory);
            var docTypeNames = [];

            if (docTypesMandatory.length > 0)
            {
                docTypesMandatory.forEach(function(item) {
                    var docName = item.lkp_DocumentTypes_AE.description;
                    docTypeNames.push(docName);
                });

                if (currentDocs.length > 0)
                {
                    var objToArray = []; var currentDocNames = [];
                    currentDocs.forEach(function(el) {
                        var elType = el.documentType;
                        objToArray.push(elType);
                    });

                    objToArray.forEach(function(el) {
                        const spaced = el.replace(/([A-Z])/g, ' $1');
                        const modified = spaced.charAt(0).toUpperCase() + spaced.slice(1);
                        currentDocNames.push(modified);
                    });

                    var hasRequiredDocTypes = docTypeNames.every(function(val) { return currentDocNames.indexOf(val) >= 0; });

                    if (hasRequiredDocTypes)
                        this.confirmSubmitPhase();
                    else
                        this.showDocWarning();
                }
                else
                    this.showDocWarning();
            }
            else
                this.confirmSubmitPhase();
        }
        else
            this.confirmSubmitPhase();
    }

    confirmSubmitPhase() {
        this.setState({ modalIsOpenSubmit: true });
    }

    showDocWarning() {
        this.setState({ docWarning: true });
        toast.warn('Please upload required documents');
    }

    confirmSavePhase() {
        this.setState({ modalIsOpenSave: true });
    }

    showLog(row) {
        this.props.getPmLogByPhaseId_AE(row.id)

        //TODO: add transition
        // if (this.props.pmLogsByPhaseId_AE.length > 0)
        this.setState({ modalIsOpenLog: true });
    }

    showDocs(phase) {
        this.setState({ modalIsOpenDoc: true });
    }

    savePhase(phase) {
        this.putTrackingPhase(phase);

        this.createTargetDateLog(phase);

        this.putMainTrack(this.state.aeTrack);
    }

    createTargetDateLog(phase) {

        var newLog = {};
        newLog.trackingPhaseId = phase.id;
        newLog.pmTargetDate = phase.targetDate;
        newLog.pmComment = this.state.pmComment;
        newLog.mainTrackingId = phase.mainTrackingId;
        newLog.phaseId = phase.phaseId;
        newLog.projectId = phase.projectId;

        this.postTargetDateLog(newLog);
    }

    postTargetDateLog(log) {
        let method = 'post';
        let url = `projects/${log.projectId}/PostPmLog`;

        withAuth(
            { method, url, data: log },
            () => {
                //       this.closeModalPhase();
                //  this.props.fetchPmTargetDateLog_AE(log.projectId);
            },
            this.errorHandler
        )
    }

    submitFirstPhase() {
        var mainTrack = {};
        mainTrack.currentPhaseId = 19;
        mainTrack.histPres = false;
        mainTrack.isPreSchematic = false;
        mainTrack.pMRequestSubmittedDate = getCurrentDate();
        mainTrack.pMRequestedPhaseId = 19;
        mainTrack.projectId = this.props.projectId;
        mainTrack.queueTypeId = 2;
        mainTrack.sustDes = true;
        mainTrack.trackId = 4;

        this.postMainTrack(mainTrack);
    }

    submitNextPhase(phase) {
        const { aeTrack } = this.state;
        phase.pmSubmittedActualDate = getCurrentDate();
        aeTrack.pMRequestSubmittedDate = getCurrentDate();
        aeTrack.queueTypeId = 2;

        this.putTrackingPhase(phase);
        this.putMainTrack(aeTrack);

        this.createTargetDateLog(phase);
    }

    postMainTrack(mainTrack) {
        let method = 'post';
        let url = `projects/${mainTrack.projectId}/AETracking`;

        withAuth(
            { method, url, data: mainTrack },
            () => {
                this.closeModal();
                this.props.getAETrackingByProjectId(mainTrack.projectId);
                this.setState({ showSavedMsg: true });
                toast.success('Saved Successfully!');
                this.callEmailFirstPhase(mainTrack);
            },
            this.errorHandler
        )
    }

    callEmailFirstPhase(mainTrack) {
        let method = 'post';
        let url = `projects/${mainTrack.projectId}/EmailFistPhaseSeparated_AE`;
    
        withAuth(
          { method, url, data: mainTrack },
        )
      }

    putTrackingPhase(phase) {
        let method = 'put';
        let url = `projects/${phase.projectId}/AETrackingPhase/${phase.id}`;

        withAuth(
            { method, url, data: phase },
            () => {
                this.closeModalPhase();
                this.props.fetchTrackingPhase_AE(phase.projectId);
            },
            this.errorHandler
        )
    }

    putMainTrack(aeTrack) {
        let method = 'put';
        let url = `projects/${aeTrack.projectId}/AETracking/${aeTrack.id}`;

        withAuth(
            { method, url, data: aeTrack },
            () => {
                this.closeModal();
                this.props.getAETrackingByProjectId(aeTrack.projectId);
                this.setState({ showSavedMsg: true });
                toast.success('Saved Successfully!');
            },
            this.errorHandler
        )
    }

    handleDocDelete() {
        const { projectId } = this.props;
        const sasEndpoint = `projects/${projectId}/documents/sas`;

        withAuth(
            { method: 'get', url: sasEndpoint },
            this.deleteBlob,
            // this.notifyError
        );
    }

    deleteBlob(result) {
        const doc = this.state.doc;
        const callback = this.delDocumentToAPI;

        const url = doc.blobUrl + result.data.signature;

        axios.delete(url, {
            headers: {
                'x-ms-blob-type': 'BlockBlob',
                'x-ms-blob-content-type': doc.type,
                'x-ms-meta-uploadvia': 'SAS Demo',
            }
        })
            .then(callback)
        // .catch(this.notifyError);
    }

    delDocumentToAPI(result) {
        const doc = this.state.doc;
        const endpoint = `projects/${doc.projectId}/documents/${doc.id}`;

        const payload = {
            ...doc,
            fileName: doc.fileName,
            documentType: doc.documentType,
        }

        withAuth(
            { method: 'delete', url: endpoint, data: payload },
            () => {
                this.reloadDocs(doc.projectId);
                this.closeModal();
            },
        )
    }

    reloadDocs(projectId) {
        this.props.getDocsByProjectId(projectId);
        this.props.fetchTrackingPhase_AE(projectId);
    }

    onDocDownload(doc) {
        const { projectId, blobUrl } = doc;
        const sasEndpoint = `projects/${projectId}/documents/sas`;

        return (e) => {
            e.preventDefault();

            withAuth(
                { method: 'get', url: sasEndpoint },
                (result) => this.startDocDownload(result, blobUrl),
               // this.notifyError
            );
        }
    }

    startDocDownload(result, blobUrl) {
        this.downloadLink.href = blobUrl + result.data.signature;
        this.downloadLink.click();
    }

    onDocDelete(doc) {
        this.setState({ deleteDoc: true, doc });
    }

    onDocDeleteCancel() {
        this.setState({ doc: null, deleteDoc: false });
    }

    renderDocDeleteModal() {
        const currentDoc = this.state.doc;
        if (currentDoc) {
            var noSpace = currentDoc.documentType.replace(/([A-Z])/g, ' $1');
            var noSpaceName = noSpace.charAt(0).toUpperCase() + noSpace.slice(1);
        }

        return (
            <Modal
                isOpen={this.state.deleteDoc}
                style={modalStyle}
                contentLabel="Comments">

                <div className="edit-area modal-form">
                    <h1>Delete Document</h1>

                    <div className="modal-close"
                        onClick={() => this.closeModal()}>
                        <span className="close"></span>
                    </div>

                    <div className="document-form">
                        <div className='required doc-filename'>
                            <label htmlFor="fileName">Name</label>
                            <input name="fileName" type="text" value={currentDoc && currentDoc.fileName} disabled={true} />
                        </div>
                        <div className='control required'>
                            <label htmlFor="documentType">Document Type</label>
                            <input name="documentType" type="text" value={currentDoc && noSpaceName && noSpaceName} disabled={true} />
                        </div>
                    </div>

                    <button className="btn-delete" onClick={this.handleDocDelete}>Delete</button>
                    <button className="doc-cancel" onClick={this.onDocDeleteCancel}>Cancel</button>

                </div>
            </Modal>
        )
    }

    renderCommentsModal() {
        return (
            <Modal
                isOpen={this.state.modalCommentsVisible}
                style={modalStyle}
                contentLabel="Comments"
            >
                <div className="alert-modal">
                    <h1>Comments</h1>
                    <div className="modal-close"
                        onClick={() => this.closeModal()}>
                        <span className="close"></span>
                    </div>
                    <p>{this.state.commentInModal}</p>
                </div>
            </Modal>
        )
    }

    renderConfirmSubmit() {
        const { aeTrack } = this.state;
        const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
        var lastItem = aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1];

        return (
            <Modal
                isOpen={this.state.modalIsOpenSubmit}
                style={modalStyle}
                contentLabel="Confirm"
            >
                <div className="member-form modal-form">
                    <div className="modal-close"
                        onClick={() => this.closeModal()}>
                        <span className="close"></span>
                    </div>

                    {aeTrack === null || aeTrack === undefined
                        ? <div><h2>Are you sure you want to submit request for service for <b>Project Objectives,</b> which will kick-off project Initiation? </h2>
                            <button className="btn-update" onClick={() => this.submitFirstPhase()}>Submit</button>
                        </div>
                        : <div>
                            <h2>Are you sure you want to submit request for service for <b>{lastItem !== undefined && lastItem.lkp_Phase_AE.phaseName}</b> submission?</h2>
                            <button className="btn-update" onClick={() => this.submitNextPhase(lastItem)}>Submit</button>
                        </div>}
                </div>
            </Modal>
        )
    }

    renderConfirmSave() {
        const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
        var lastItem = aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1];

        return (
            <Modal
                isOpen={this.state.modalIsOpenSave}
                style={modalStyle}
                contentLabel="Confirm"
            >
                <div className="member-form modal-form">
                    <div className="modal-close"
                        onClick={() => this.closeModal()}>
                        <span className="close"></span>
                    </div>

                    <h2> Your target date for submission has been successfully changed.</h2>
                    <button className="btn-update" onClick={() => this.savePhase(lastItem)}>Save</button>
                </div>
            </Modal>
        )
    }

    renderLogModal() {
        const pmLogsByPhaseId_AE = this.props.pmLogsByPhaseId_AE;

        return (
            <Modal
                isOpen={this.state.modalIsOpenLog}
                style={mediumModalStyle}
                contentLabel="Confirm"
            >
                <div className="member-form modal-form">
                    <div className="modal-close"
                        onClick={() => this.closeModal()}>
                        <span className="close"></span>
                    </div>

                    <h2>Project manager submission log</h2>

                    {pmLogsByPhaseId_AE.length > 0 &&
                        <div className="project-detail-comments">
                            <div className="col s12">
                                <div className="table-wrap">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Target Date for submission</th>
                                                <th>Comments</th>
                                                <th>Created by</th>
                                                <th>Created date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {_.orderBy(pmLogsByPhaseId_AE, ['createdDate'], ['desc']).map(log =>
                                                <tr key={log.id}>
                                                    <td>{getDateValue(log.pmTargetDate)}</td>
                                                    <td>{log.pmComment}</td>
                                                    <td>{log.createdBy}</td>
                                                    <td>{getDateValue(log.createdDate)}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Modal>
        )
    }

    render() {
        const { aeTrack, pmComment } = this.state;
        const aeTrackBottomPartArray = this.state.aeTrackBottomPartArray;
        const { permissions } = this.props;

        var lastItem = aeTrackBottomPartArray[aeTrackBottomPartArray.length - 1];
        let canSubmit = permissions.canSubmitRequestForServ;

        var dateToday = getCurrentDate();

        return (
            <div id="requestForServices">
                <div id="aeTracking" className="row-wide ae-tracking">

                    <div className='row'>
                        <div className="col s12">
                            <h4 className="bar-bottom">Request for Services</h4>
                        </div>
                    </div>

                    {this.renderCommentsModal()}

                    {this.renderConfirmSubmit()}

                    {this.renderConfirmSave()}

                    {this.renderLogModal()}

                    {this.renderDocDeleteModal()}

                    {this.state.showSavedMsg &&
                        <ToastContainer
                            hideProgressBar={true}
                            newestOnTop={true}
                            autoClose={2000}
                            position={'top-center'}
                        />}

                    {this.state.docWarning &&
                        <ToastContainer
                            hideProgressBar={true}
                            newestOnTop={true}
                            autoClose={2000}
                            position={'top-center'}
                        />}

                    {aeTrack !== undefined &&
                        <div className="row" id='borderRfs'>                       
                                <div className="col s12 m3 l3 padding-left-0">
                                    <div className="controls">
                                        <label>Request Status</label>
                                        <span>{this.getStatusTracking(aeTrack.statusTrackingId)}</span> 
                                    </div>
                                </div>

                                <div className="col s12 m9 l9 padding-left-0 padding-right-0">
                                    <div className="controls">
                                        <label>Comment</label>
                                        <span>{aeTrack.comment}</span>
                                    </div>
                                </div>                       
                        </div>
                    }  

                    <a className='downloadDocRfs' ref={link => this.downloadLink = link}>Download</a>

                    <div className="col s12 rf-table-scroll">
                        <div className="table">
                            <table className="td-table-border th-table-border table-striped">
                                <thead>
                                    <tr>
                                        <th colSpan="4" className="text-center">PM Queue</th>
                                        <th colSpan="10" className="text-center">A&E Queue</th>
                                    </tr>
                                    <tr>
                                        <th>Phase</th>
                                        <th className="field-required-custom">Target Date for submission</th>
                                        <th>Date submitted by PM</th>
                                        <th className="field-required-custom">Comments</th>
                                        {/* <th>Documents</th>  */}
                                        <th>A&E - Intake</th>
                                        <th>A&E Accepted Date</th>
                                        <th>A&E Rejected Date</th>
                                        <th>A&E Target Date</th>
                                        <th>Actual Duration/Target Days for Review</th>
                                        <th>A&E Actual Reviewed Date</th>
                                        <th>Review Status</th>
                                        <th>Comments</th>
                                        <th>Bluebeam Session Id</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {aeTrack === undefined || aeTrackBottomPartArray.length === 0
                                        ? <tr>
                                            <td>Project Objectives</td>
                                            <td>N/A</td>
                                            <td>{aeTrack !== undefined && getDateValue(aeTrack.pmRequestSubmittedDate)}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                {aeTrack === undefined && canSubmit
                                                    && <button className="btn-save margin-left-0 margin-top-075" onClick={this.validateSubmission}>
                                                        Submit
                                                </button>}
                                            </td>
                                        </tr>

                                        : aeTrackBottomPartArray.length > 0
                                            ? aeTrackBottomPartArray.map((row, index) =>
                                                <tr key={row.id}>

                                                    <td>{row.lkp_Phase_AE.phaseName}</td>

                                                    <td className="fixed-datePicker">{lastItem.id === row.id && aeTrack.queueTypeId === 1 && aeTrack.currentPhaseId !== null && canSubmit && aeTrack.statusTrackingId !== 3
                                                        ? <DateField
                                                            name='targetDate'
                                                            value={row.targetDate}
                                                            limits={{ dateAbove: dateToday }} 
                                                            onChange={this.handleDateChange('targetDate', index)} />
                                                        : row.targetDate === null
                                                            ? <span>N/A</span>
                                                            : getDateValue(row.targetDate)}</td>

                                                    <td>{getDateValue(row.pmSubmittedActualDate)}</td>

                                                    <td> {lastItem.id === row.id && aeTrack.queueTypeId === 1 && aeTrack.currentPhaseId !== null && canSubmit && aeTrack.statusTrackingId !== 3
                                                        ? <textarea id="textarea-custom-bordered" rows="3" maxLength="1500"
                                                            name="pmComment" value={pmComment}
                                                            onChange={this.handleChangeComment('pmComment')}>
                                                        </textarea>
                                                        : row.lkp_Phase_AE.phaseName === 'Project Objectives' && row.targetDate

                                                            ? <a href='# ' className='log-history' onClick={() => this.showLog(row)}>
                                                                View History</a>
                                                            : row.lkp_Phase_AE.phaseName === 'Project Objectives' && !row.targetDate

                                                                ? 'N/A'
                                                                : <a href='# ' className='log-history' onClick={() => this.showLog(row)}>
                                                                    View History</a>}
                                                    </td>

                                                    <td>
                                                        <span>{row.intakeAccepted === true && row.aeAcceptedDate
                                                            ? 'Accepted'
                                                            : row.intakeAccepted === false && row.aeRejectedDate
                                                                ? 'Rejected'
                                                                : ''}</span>
                                                    </td>

                                                    <td>{getDateValue(row.aeAcceptedDate)}</td>
                                                    <td>{getDateValue(row.aeRejectedDate)}</td>
                                                    <td>{getDateValue(row.aeTargetDate)}</td>

                                                    <td>{row.aeAcceptedDate !== undefined && row.aeAcceptedDate !== '' && row.aeAcceptedDate !== null
                                                        ? <span>{this.calcDaysRemaining(row)} / 21</span> : null}</td>

                                                    <td>{getDateValue(row.aeActualReviewedDate)}</td>

                                                    <td>{row.reviewStatusId !== null && row.reviewStatusId !== '' && row.reviewStatusId !== undefined
                                                        ? this.getReviewStatusName(row.reviewStatusId) : null}
                                                    </td>

                                                    <td className='max-width-200'>
                                                        <p className='ellipsis' onClick={() => this.showCommentsModal(row)}>{row.comments}</p>
                                                    </td>

                                                    <td>
                                                        <span>{row.bluebeamSessionId}</span>
                                                    </td>

                                                    <td>
                                                        {lastItem.id === row.id && aeTrack.queueTypeId === 1 && aeTrack.currentPhaseId !== null && canSubmit && aeTrack.statusTrackingId !== 3 &&
                                                            <button className="btn-save margin-left-0" onClick={this.confirmSavePhase}
                                                                disabled={row.targetDate === null || row.targetDate === '' || pmComment === '' || pmComment === null}>
                                                                SAVE
                                                         </button>}

                                                        {lastItem.id === row.id && aeTrack.queueTypeId === 1 && aeTrack.currentPhaseId !== null && canSubmit && aeTrack.statusTrackingId !== 3 &&
                                                            <button className="btn-save margin-left-0 margin-top-075 margin-bottom-075" onClick={this.confirmSubmitPhase}
                                                                disabled={row.targetDate === null || row.targetDate === '' || pmComment === '' || pmComment === null}>
                                                                Submit
                                                         </button>}

                                                    </td>

                                                </tr>
                                            )
                                            : null}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        aeTracksMain: state.additionalProjectsStore.aeTracksMain,
        trackingPhases_AE: state.additionalProjectsStore.trackingPhases_AE,
        reviewStatuses_AE: state.additionalProjectsStore.reviewStatuses_AE,
        pmLogsByPhaseId_AE: state.additionalProjectsStore.pmLogsByPhaseId_AE,
        pmLogsByProjectId_AE: state.additionalProjectsStore.pmLogsByProjectId_AE,
        statusTracking_AE: state.additionalProjectsStore.statusTracking_AE,
        docs_AE: state.additionalProjectsStore.docs_AE,
        docTypes_AE: state.additionalProjectsStore.docTypes_AE
    }
}

export default connect(mapStateToProps, {
    getAETrackingByProjectId, fetchTrackingPhase_AE,
    fetch_lkp_ReviewStatus_AE, getPmLogByPhaseId_AE, getPmLogByProjectId_AE, getDocsByProjectId,
    getDocTypesAEByPhaseId, fetch_lkp_StatusTracking_AE
})(RfsNew);